import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const LyricsShadowDistanceListItem = (props) => {
    const { shadowSettingsDistance, updateLyricsStyle, maxDropShadowDistance } = props;

    const onShadowDistanceChange = (value) => {
        previewHistoryBatch.start();

        updateLyricsStyle({
            shadowSettings: { distance: value }
        });
    };

    return (
        <SliderListItem
            title='Distance'
            value={shadowSettingsDistance}
            displayMultiplier={1}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowDistanceChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { shadowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const shadowSettingsDistance = shadowSettings ? (shadowSettings.distance ?? 0) : 0;
    const { maxDropShadowDistance } = state.create.maxValues;

    return {
        shadowSettingsDistance,
        maxDropShadowDistance: maxDropShadowDistance || 20
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsShadowDistanceListItem);
